module.exports = __webpack_public_path__ + "img/small-1.17dd329f.jpg";